import { ComponentType, createContext } from "react";
import { SingletonPopoverState } from "./types";

export interface SingletonPopoverContextValue {
  // oxlint-disable-next-line typescript/no-explicit-any
  openPopover: <TComponent extends ComponentType<any> = ComponentType<any>>(
    state: SingletonPopoverState<TComponent>
  ) => void;
  closePopover: () => void;
  isPopoverOpen: (popoverId: string) => boolean;
  _hasContext: boolean;
}

export const SingletonPopoverContext =
  createContext<SingletonPopoverContextValue>({
    openPopover: () => {},
    closePopover: () => {},
    isPopoverOpen: () => false,
    _hasContext: false,
  });
